import { useDispatch } from "react-redux";

// Redux 5 endurecio el tipo de dispatch a Dispatch<UnknownAction>, pero los
// action creators de este proyecto estan declarados como () => void (patron
// heredado de redux-actions). Este hook restaura el comportamiento laxo que
// teniamos con Redux 4 para no refactorizar cada action creator.
export const useAppDispatch = useDispatch as () => (action: any) => any;
